<div class="modal-body" *ngIf="dataLoaded">
    <p><b>{{message}}</b></p>
    <table class="mvd_table--primeng">
        <thead>
            <tr>
                <th>Nmvtis Brand</th>
                <th>Equivalent AZ Brand</th>
                <th>Date</th>
                <th>Reporting Entity</th>
                <th>Recognized By Arizona</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let b of nmvtisBrands">
                <td>{{b.nmvtisDisplayValue}}</td>
                <td>{{b.vehicleBrandName}}</td>
                <td>{{b.vehicleBrandDate | shortDate}}</td>
                <td>{{b.reportingEntityName}}</td>
                <td>{{b.isRecognized}}</td>
            </tr>
        </tbody>

    </table>
    <div class="modal-footer">
        <div class="btn--group">
            <button class="btn--default" type="button" (click)="onCancelClick()">Cancel</button>
            <button class="btn--primary" type="submit" (click)="onSaveClick()">Ok</button>
        </div>
    </div> 
</div>
